export default __webpack_public_path__ + "static/media/3-reducao-risco.cd444f55.svg";